/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 */
import { api } from '../../../config/api';

import type { InstagramAuthLinkData } from '../types';

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getSettingsInstagramAuthLink: build.query<InstagramAuthLinkData, void>({
      query: () => ({ method: 'GET', url: `/v1/settings/instagram/auth-link` }),
    }),
  }),
  overrideExisting: true,
});

export { injectedRtkApi as getSettingsInstagramAuthLinkApi };
export const { useGetSettingsInstagramAuthLinkQuery, useLazyGetSettingsInstagramAuthLinkQuery } = injectedRtkApi;
